import { ref, Ref } from 'vue';
const activePreStation: Ref<string> = ref('');
export { activePreStation };
